import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupD5 } from "../../../../../redux/app/orb3/groups/group-d";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupD5PreviewProps = OwnProps;

function ORB3GroupD5Preview(props: ORB3GroupD5PreviewProps) {
	const record = props.orb3Record as TORB3GroupD5;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemD5 } = record;

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[
						operationDate,
						"3-D",
						"5",
						`Port Name: ${itemD5.portName || "-"}, Position: ${
							itemD5.latitude || "-"
						} / ${itemD5.longitude || "-"}`,
					],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupD5Preview;
